import {
  ColDef,
  GetRowIdParams,
  GridApi,
  GridOptions,
} from 'ag-grid-community';
import { Injectable } from '@angular/core';
import { Region } from '@compumark/order-management-client';

import { RegionRendererComponent } from '../../columns/register-renderer/region-renderer.component';
import { CustomSelectAllHeaderComponent } from '../add-watch-order/custom-select-all-header/custom-select-all-header.component';
import { formatClasses } from '../../columns/column-definition/set-filter-helpers';

@Injectable({
  providedIn: 'root',
})
export class OrderGridOptionService {
  private columnDefs: ColDef[];
  private gridApi?: GridApi;

  constructor() {
    this.columnDefs = [
      {
        headerName: '',
        field: 'select',
        checkboxSelection: true,
        showDisabledCheckboxes: true,
        headerComponent: CustomSelectAllHeaderComponent,
        suppressHeaderMenuButton: true,
        pinned: 'left',
        lockPosition: true,
        width: 10,
        cellStyle: {
          paddingLeft: '0.857rem',
        },
        headerClass: 'checkbox-header',
        resizable: false,
      },
      {
        headerName: 'Trademark',
        field: 'trademarkName',
        pinned: 'left',
        lockPinned: true,
        sort: 'asc',
        width: 170,
        minWidth: 100,
        sortable: false,
        suppressHeaderMenuButton: true,
      },
      {
        headerName: 'Product',
        field: 'productName',
        width: 150,
        minWidth: 100,
        sortable: false,
        suppressHeaderMenuButton: true,
      },
      {
        headerName: 'Your Reference',
        field: 'clientReference',
        width: 150,
        minWidth: 100,
        sortable: false,
        suppressHeaderMenuButton: true,
      },
      {
        headerName: 'Sub Client Reference',
        field: 'subClientReference',
        width: 170,
        minWidth: 100,
        sortable: false,
        suppressHeaderMenuButton: true,
      },
      {
        headerName: 'Region',
        field: 'regions',
        cellRenderer: RegionRendererComponent,
        width: 300,
        minWidth: 100,
        sortable: false,
        suppressHeaderMenuButton: true,
        getQuickFilterText: (params) =>
          params.value
            .map((r: Region) => r.label + (r.limited ? ' (Limited)' : ''))
            .filter((label: string) => label.trim() !== '')
            .join(' '),
      },
      {
        headerName: 'Classes',
        field: 'classes',
        width: 150,
        minWidth: 100,
        sortable: false,
        suppressHeaderMenuButton: true,
        valueFormatter: formatClasses,
        getQuickFilterText: formatClasses,
      },
    ];
  }
  public get gridOptions(): GridOptions {
    return {
      theme: 'legacy',
      rowModelType: 'clientSide',
      columnDefs: this.columnDefs,
      defaultColDef: {
        resizable: true,
        suppressKeyboardEvent: () => {
          return true;
        },
      },
      suppressContextMenu: true,
      rowHeight: 50,
      headerHeight: 35,
      rowSelection: 'multiple',
      suppressHorizontalScroll: true,
      suppressColumnVirtualisation: true,
      suppressRowHoverHighlight: true,
      suppressCellFocus: true,
      suppressRowClickSelection: true,
      suppressDragLeaveHidesColumns: true,
      getRowId: (params: GetRowIdParams) => params.data.id,
      getRowClass: (params) =>
        params.data?.selectedFrom === 'dropdown' ? 'selected-dropdown' : '',
    };
  }

  setGridApi(api: GridApi): void {
    this.gridApi = api;
  }

  clearGridApi(): void {
    this.gridApi = undefined;
  }

  public getGridApi(): GridApi | undefined {
    return this.gridApi;
  }
}
